import React from 'react';
import PropTypes from 'prop-types';
import {FormattedDate, FormattedMessage} from 'react-intl';

// CSS
import './index.scss';

/**
 * This functional component show event date and time
 * @param eventDate
 * @param eventTime
 */
const EventDateTimeInfo = ({eventDate, eventTime}) => {
  return (
    <div className="EventDateTimeInfo">
      <span className="EventDateTimeInfo__date">
        {eventDate ? (
          <FormattedDate weekday="short" value={eventDate} month="short" day="2-digit" year="numeric" />
        ) : (
          <FormattedMessage defaultMessage="TBD" id="EventDetailInfo.TBD" />
        )}
      </span>
      &nbsp;•&nbsp;
      <time className="EventDateTimeInfo__time">{eventTime}</time>
    </div>
  );
};

EventDateTimeInfo.propTypes = {
  /* Date Object */
  eventDate: PropTypes.object,

  /* React element for time */
  eventTime: PropTypes.element.isRequired,
};

export default EventDateTimeInfo;
